import useAddEventListener, {
  EventListenerConfig,
} from 'hooks/useAddEventListener';

type UseKeyUpOptions = {
  onKeyUp: (e: KeyboardEvent) => void;
} & EventListenerConfig;

export default function useKeyUp({ onKeyUp, ...props }: UseKeyUpOptions) {
  useAddEventListener({
    event: 'keyup',
    handler: onKeyUp,
    ...props,
  });
}
